<sysque-frame [componentTitle]="componentTitle">
  <div class="content-container">
    <div class="tabs-container">
      <modus-tabs [tabs]="tabs" size="small" (tabChange)="onTabChange($event)"></modus-tabs>
    </div>
    @if (activeTab === 'Keyboard Shortcuts') {
      <div>
        <div class="keyboard-shortcuts">
          @for (item of items; track item; let i = $index) {
            <div class="keyboard-shortcuts-content">
              <label class="feature-shortcut">{{ item.optionMenu }}</label>
              <div [ngClass]="isElementInvalid(item) ? 'error-visible' : 'error-hidden'">
                <span id="iconAlert-{{ i }}" class="error-icon" (mouseover)="showErrorMessage(item)"> &#9888; </span>
                <dx-tooltip
                  target="#iconAlert-{{ i }}"
                  position="top"
                  showEvent="mouseenter"
                  position="top"
                  hideEvent="mouseleave"
                  [hideOnOutsideClick]="false"
                >
                  <div>{{ errorMessage }}</div>
                </dx-tooltip>
              </div>

              <dx-select-box
                [items]="optionsKeyOne"
                [placeholder]="placeholders[1]"
                (onValueChanged)="onValueChanged('modifiers', item, $event)"
                [value]="isRevertButtonClicked ? placeholders[1] : setDefaultModifier(item)"
              ></dx-select-box>
              <dx-select-box
                [items]="optionsKeyTwo"
                [placeholder]="placeholders[2]"
                (onValueChanged)="onValueChanged('keyOne', item, $event)"
                [value]="isRevertButtonClicked ? placeholders[2] : setDefaultKeyOne(item)"
              ></dx-select-box>
              <dx-select-box
                [items]="optionsKeyThree"
                [placeholder]="placeholders[3]"
                (onValueChanged)="onValueChanged('keyTwo', item, $event)"
                [value]="isRevertButtonClicked ? placeholders[3] : setDefaultKeyTwo(item)"
              ></dx-select-box>
            </div>
          }
        </div>
        <div class="restore-button">
          <dx-button
            id="restore-button-content"
            class="revert-container"
            text="{{ data.restoreName }}"
            (onClick)="onRevertClick()"
          ></dx-button>
        </div>
      </div>
    }

    @if (activeTab === 'Preferences') {
      <div class="preferences-container">
        <div class="preferences">
          <div class="my-1 switch-elements">
            <label>Enable Tool Tips</label>
            <modus-switch
              (click)="onEnableTooltipClick()"
              checked="{{ isEnableTooltips }}"
              label=""
              size="medium"
              class="switch-sc"
            ></modus-switch>
          </div>
          <div class="my-1 switch-elements">
            <label>Enable Worksharing Alerts</label>
            <modus-switch
              (click)="onWorksharingClick()"
              checked="{{ isWorksharingAlerts }}"
              label=""
              size="medium"
              class="switch-sc"
            ></modus-switch>
          </div>
          <div class="my-1 switch-elements">
            <label>Edit and Delete in Add Fittings view only</label>
            <modus-switch
              (click)="onEditDeleteAddFittingClick()"
              checked="{{ isEditDeleteAddFitting }}"
              label=""
              size="medium"
              class="switch-sc"
            ></modus-switch>
          </div>
          @if (!isConduitRunSelectionVisible) {
            <div class="my-1 switch-elements">
              <label>Auto Process Nominal Size Values</label>
              <modus-switch
                (click)="onNominalSizeClick()"
                checked="{{ isNominalSize }}"
                label=""
                size="medium"
                class="switch-sc"
              ></modus-switch>
            </div>
          }
          @if (isConduitRunSelectionVisible) {
            <div class="my-1 switch-elements">
              <label>Conduit Run selection</label>
              <modus-switch
                (click)="onConduitRunSelectionClick()"
                checked="{{ isConduitRunSelection }}"
                label=""
                size="medium"
                class="switch-sc"
              ></modus-switch>
            </div>
          }

          <div class="my-1 description-container">
            <div class="description-element">
              <label>Image Description</label>
              <dx-select-box
                [items]="imageDescription"
                (onValueChanged)="onImageDescritpionChanged($event)"
                [value]="imageDescriptionChanged"
              ></dx-select-box>
            </div>
            <div class="description-element">
              <label>Alternate Description</label>
              <dx-select-box
                [items]="alternateDescription"
                (onValueChanged)="onAlternateDescritpionChanged($event)"
                [value]="alternateDescriptionChanged"
              ></dx-select-box>
            </div>
          </div>

          <div class="my-1 selection-element-container">
            <label class="display-none rotation-angle-label">Fitting Rotation Angle Increment(degrees)</label>
            <input
              id="rotation-angle"
              class="display-none rotation-angle-input"
              type="number"
              [value]="fittingRotation !== null ? fittingRotation : ''"
              min="1"
              max="200"
              step="0.0001"
              (input)="onFittingRotationChange($event)"
            />
            <label>SysQue Connect Size(inches)</label>
            <input
              id="connect-size"
              type="number"
              [value]="connectSize !== null ? connectSize : ''"
              min="1"
              max="200"
              step="0.0001"
              (input)="onConnectSizeChange($event)"
            />
          </div>
        </div>
      </div>
    }
    <div class="alert-div">
      @if (isAlertVisible) {
        <alert [alert]="alert" (alertClosed)="onDismissClick()"></alert>
      }
    </div>
  </div>
  <div class="bottom-container">
    <dx-button
      id="apply-button"
      class="apply-container"
      text="{{ data.applyName }}"
      (onClick)="onApplyClick()"
      [disabled]="false"
    ></dx-button>
  </div>
</sysque-frame>
